/**
 * 结合私有化品牌定制 和 代理商品牌定制
 */

import { computed, ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { CURRENT_PROJECT_SUBJECT } from '@/project-subject/project-subject'
import { IS_PRIVATE } from '@/common/const/env'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { themeRef } from '@/utils/app-theme'
import { i18n } from '@/i18n'

export const PRIVATE_BRAND_IMG = {
  favicon: '/private-config/images/favicon.ico',
  logo_dashboard_header: '/private-config/images/logo-dashboard-header.png',
  logo_login_page: '/private-config/images/logo-login-page.png',
}

export const BRAND_IMG = (() => {
  const imgMap = PRIVATE_BRAND_IMG
  if (!IS_PRIVATE) {
    imgMap.logo_dashboard_header = CURRENT_PROJECT_SUBJECT.logo_dashboard_header
    imgMap.logo_login_page = CURRENT_PROJECT_SUBJECT.logo_login_page
  }
  if (IS_JP_ONLY_BUILD) {
    imgMap.logo_dashboard_header = require('@/assets/jp-home-head.png')
    imgMap.logo_login_page = require('@/assets/jp-login.png')
  }
  return imgMap
})()

/** 控制台头部 logo（暗模式）：JP 用专用暗色图；私有化读 private-config 下的暗色图 */
const DARK_LOGO_DASHBOARD_HEADER = IS_JP_ONLY_BUILD
  ? require('@/assets/jp-home-head-dark.png')
  : IS_PRIVATE
    ? '/private-config/images/logo-dashboard-header-dark.png'
    : CURRENT_PROJECT_SUBJECT.logo_dashboard_header_dark

/** 控制台头部 logo 地址，随主题切换（暗模式 logo 为浅色图，深色底上按原样显示） */
export const logoDashboardHeaderSrc = computed(() =>
  themeRef.value === 'dark' ? DARK_LOGO_DASHBOARD_HEADER : BRAND_IMG.logo_dashboard_header
)

export interface BrandConfig {
  /** 网页端名称 */
  project_name: string
  /** 客户端名称 */
  client_name: string
  /** 是否品牌自定义 */
  is_brand_custom: boolean
}

function getBrandConfig (): BrandConfig {
  return {
    project_name: i18n.global.t('authDialog.brandProjectName'),
    client_name: i18n.global.t('authDialog.brandClientName'),
    is_brand_custom: false,
  }
}

export const useBrandCustomStore = defineStore('brand-custom', () => {
  const brandConfig = ref<BrandConfig>(getBrandConfig())

  function initBrandCustom () {
    watch(() => i18n.global.locale.value, () => {
      brandConfig.value = getBrandConfig()
      handleBrand()
    })
    handleBrand()
  }

  function handleBrand () {
    const favicon = document.querySelector('link[rel="icon"]') as any
    if (favicon) {
      favicon.href = BRAND_IMG.favicon
    }
    document.title = brandConfig.value.project_name
  }

  return {
    brandConfig,
    initBrandCustom,
  }
})
